// extracted by mini-css-extract-plugin
export default {"app":"A5eEbyCiBbYOJmfpIPp+bw=="};